import { render, staticRenderFns } from "./DeleteNoteDialog.vue?vue&type=template&id=470f6f51&"
import script from "./DeleteNoteDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports